function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../../framework/publisher2/tools/AbstractPublisherTool';
import { SwipeToolComponent } from './SwipeToolComponent';
export var SWIPE_ID = 'Oskari.mapframework.bundle.layerswipe.plugin.LayerSwipePlugin';
var SwipeTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function SwipeTool() {
    var _this;
    _classCallCheck(this, SwipeTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SwipeTool, [].concat(args));
    _this.index = 40;
    _this.group = 'tools';
    return _this;
  }
  _inherits(SwipeTool, _AbstractPublisherToo);
  return _createClass(SwipeTool, [{
    key: "getTool",
    value: function getTool() {
      return {
        id: SWIPE_ID,
        title: Oskari.getMsg('LayerSwipe', 'tool.label'),
        config: this.state.pluginConfig || {}
      };
    }
  }, {
    key: "getHandler",
    value: function getHandler() {
      var _this$getSandbox$find;
      return (_this$getSandbox$find = this.getSandbox().findRegisteredModuleInstance('LayerSwipe')) === null || _this$getSandbox$find === void 0 ? void 0 : _this$getSandbox$find.getHandler();
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      var handler = this.getHandler();
      if (!handler) {
        return {};
      }
      return {
        component: SwipeToolComponent,
        handler: handler
      };
    }
  }, {
    key: "init",
    value: function init(data) {
      var _data$configuration;
      var _ref = (data === null || data === void 0 || (_data$configuration = data.configuration) === null || _data$configuration === void 0 ? void 0 : _data$configuration.layerswipe) || {},
        state = _ref.state,
        conf = _ref.conf;
      var _ref2 = state || {},
        _ref2$active = _ref2.active,
        active = _ref2$active === void 0 ? false : _ref2$active;
      var handler = this.getHandler();
      // Store config before setEnable because it creates plugin which requires config
      this.storePluginConf(conf);
      handler === null || handler === void 0 || handler.setHideUI(!!(conf !== null && conf !== void 0 && conf.noUI));
      handler.setActive(active);
      if (conf || active) {
        this.setEnabled(true);
      }
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this$getPlugin, _this$getHandler;
      if (!this.isEnabled()) {
        return null;
      }
      var config = ((_this$getPlugin = this.getPlugin()) === null || _this$getPlugin === void 0 ? void 0 : _this$getPlugin.getConfig()) || {};
      var _ref3 = ((_this$getHandler = this.getHandler()) === null || _this$getHandler === void 0 ? void 0 : _this$getHandler.getState()) || {},
        _ref3$active = _ref3.active,
        active = _ref3$active === void 0 ? false : _ref3$active,
        _ref3$noUI = _ref3.noUI,
        noUI = _ref3$noUI === void 0 ? false : _ref3$noUI;
      return {
        configuration: {
          layerswipe: {
            conf: _objectSpread(_objectSpread({}, config), {}, {
              noUI: noUI
            }),
            state: {
              active: active
            }
          }
        }
      };
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.SwipeTool', SwipeTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});